import React from 'react'
import { Button } from 'semantic-ui-react'

import useModal from 'hooks/useModal'
import MultiStepCustomerImportModal from '../MultiStepCustomerImportModal'

export default function ImportCustomerButton({ onCsvUpload }) {
  const { open, close, Modal } = useModal()

  return (
    <React.Fragment>
      <Button onClick={open}>
        <i className="far fa-cloud-upload icon" />
        Import customers
      </Button>
      <Modal>
        <MultiStepCustomerImportModal onCsvUpload={onCsvUpload} closeModal={close} />
      </Modal>
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/ImportCustomerButton/index.js